"use client";
import React from "react";
import { IconSquareDashedPointer } from "../Icons";
import { cn } from "../utils";

interface BubbleMenuButtonProps {
  /**
   * Whether the inspector is currently active
   */
  isInspecting: boolean;

  /**
   * Click handler for the button
   */
  onClick: () => void;
}

/**
 * The main floating button for toggling the element inspector
 */
export function BubbleMenuButton({
  isInspecting,
  onClick,
}: BubbleMenuButtonProps) {
  const title = isInspecting
    ? "Disable Element Inspector"
    : "Enable Element Inspector";

  return (
    <button
      onClick={onClick}
      className={cn(
        "flex items-center justify-center p-2 rounded-full shadow-md transition-colors",
        isInspecting 
          ? "bg-[#2563eb] hover:bg-[#1d4ed8]" 
          : "bg-[#93c5fd] hover:bg-[#60a5fa]"
      )}
      title={title}
    >
      <IconSquareDashedPointer />
    </button>
  );
}
